import React, { PropsWithChildren } from 'react';
import styles from './LabeledField.module.scss';

type LabeledFieldOwnProps = {
  className?: string;
  fieldValue?: string | number;
  fieldLabel?: string;
  style?: React.CSSProperties;
  cmpStyle?: React.CSSProperties;
  labelSize?: number;
};
type LabeledFieldProps = PropsWithChildren<LabeledFieldOwnProps>;
const LabeledField: React.FC<LabeledFieldProps> = ({
  className = '',
  fieldLabel,
  fieldValue = '',
  style,
  cmpStyle,
  children,
  labelSize,
}) => {
  const baseCls = `${styles.LabeledFieldContainer} ${className}`;
  const labelSizeStyle = labelSize ? { minWidth: `${labelSize}px` } : {};
  return (
    <div className={baseCls} style={cmpStyle}>
      <span className={styles.LabeledFieldLabel} style={{ ...style, ...labelSizeStyle }}>
        {fieldLabel}
      </span>
      {children ? children : fieldValue ? <span className={styles.LabeledFieldValue}>{fieldValue}</span> : null}
    </div>
  );
};

export default LabeledField;
